// extracted by mini-css-extract-plugin
export default {"banner":"AnalyticsConsent_banner__BT+4L","actions":"AnalyticsConsent_actions__E2aRC","primary":"AnalyticsConsent_primary__Yshbi","secondary":"AnalyticsConsent_secondary__58Ld5"};